module.exports = __webpack_public_path__ + "components/flag/static/square/tt-5f874587edd948eb7105ee787fd09606.svg";